import React from 'react';
import { AudioLines, Loader2 } from 'lucide-react';

const RealtimeVoiceButton = ({
  onToggle,
  isConnecting,
  isConnected,
  disabled,
  supported = true,
  tooltipText = 'Use Voice',
}) => {
  const isDisabled = disabled || !supported;

  const getButtonClassName = () => {
    if (isDisabled) {
      return 'cursor-not-allowed bg-gray-300 text-gray-500 dark:bg-gray-700 dark:text-gray-500';
    }
    return 'bg-black text-white hover:bg-black/90 dark:bg-white dark:text-black dark:hover:bg-white/90';
  };

  return (
    <div className="relative group">
      <button
        type="button"
        onClick={onToggle}
        disabled={isDisabled}
        aria-pressed={isConnected}
        aria-label={tooltipText}
        title={tooltipText}
        className={`
          relative
          h-11 w-11
          rounded-full
          flex
          items-center
          justify-center
          transition-all
          duration-150
          ${getButtonClassName()}
        `}
      >
        {isConnected && (
          <span className="absolute inset-0 rounded-full ring-2 ring-black/20 dark:ring-white/25 animate-pulse" />
        )}
        {isConnecting ? (
          <Loader2 size={18} className="animate-spin" />
        ) : (
          <AudioLines size={18} strokeWidth={2.3} />
        )}
      </button>
    </div>
  );
};

export default RealtimeVoiceButton;
